import log from './services/log';

export const apiUrls = {
  appMarketApiUrl: '/_api/app-market-api',
  reviewsApiUrl: '/_api/reviews-server',
  wixAppMarketUrl: '/_api/wix-app-market',
  biProfileServerUrl: '/_api/wix-bi-profile-webapp',
  metaSiteWebAppUrl: '/_api/wix-dashboard-ng-webapp'
};

export const urls = {
  myAccount: 'https://www.wix.com/my-account',
  suggestAnApp: '/wix-app-market/editor/wishList',
  reviewsPublicWindow: '//www.wix.com/reviews-server/public-window',
  frogDomain: 'frog.wix.com',
  signIn: 'https://users.wix.com/signin',
  siteSelector: 'https://www.wix.com/my-account/site-selector/',
  editorEdit: 'http://editor.wix.com/html/editor/web/renderer/edit/',
  shareTwitter: 'https://twitter.com/intent/tweet?url={url}&text={title}%0D%0A{text}',
  shareFacebook: 'https://www.facebook.com/sharer/sharer.php?u={url}'
};


let clientTopology = {};

export function setClientTopology(configToUse) {
  clientTopology = configToUse;
}

export function exportClientTopology(config) {
  return Object.assign({}, config.clientTopology, apiUrls);
}

const config = {
  get topology() {
    return clientTopology;
  }
};

export default config;



/**
 * ONLY CLIENT SIDE
 * getStateDuplicate is a duplicate of Redux store.getState
 * Use it only on edge cases when it is too complicated to pass data through props to deep components and services
 */
let getStateDuplicate = () => ({});

export function setGetClientState(getState) {
  getStateDuplicate = getState;
}

export function getClientState() {
  return getStateDuplicate();
}

/**
 * Petri experiments
 * @param name
 * @param experiments
 * @returns {boolean}
 */
export function isExperiment(name, experiments = {}) {
  if (experiments[name] === undefined) {
    log.debug(`Experiment [${name}] was not conducted`);
  }
  return experiments[name] === 'true' || experiments[name] === 'new';
}



// WEBPACK FOOTER //
// ./config.js